import usePlayer from '../contexts/usePlayer';

export default function ProgressBar() {
  const { currentTime, nowPlaying } = usePlayer();
  const progress =
    nowPlaying?.secondsTotal && nowPlaying.secondsTotal > 0
      ? currentTime / nowPlaying.secondsTotal
      : 0;

  return (
    <div
      style={{
        display: 'flex',
        width: '100%',
        height: '5px',
      }}
    >
      <div
        style={{
          width: `${progress * 100}%`,
          backgroundColor: 'var(--teal)',
        }}
      />
      <div
        style={{
          width: `${(1 - progress) * 100}%`,
          backgroundColor: 'var(--border)',
        }}
      />
    </div>
  );
}
